import { useMutation, useQueryClient } from 'react-query';

import { USER_ONBOARDING_KEY, incrementOnboardingAttempt } from '@utils/backend-api/userOnboarding';

export default function useUserOnboardingIncrementAttempt() {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    () => incrementOnboardingAttempt(),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_ONBOARDING_KEY);
      },
    }
  );

  return {
    incrementOnboardingAttempt: mutate,
    incrementOnboardingAttemptAsync: mutateAsync,
    isIncrementingOnboardingAttempt: isLoading,
    isErrorIncrementingOnboardingAttempt: isError,
  };
}
